import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DictionaryItem } from 'voxloud-types/dist/models/ai-assistant/index';

@Component({
  selector: 'gdp-create-update-dictionary-form',
  templateUrl: './create-update-dictionary-form.component.html',
  styleUrls: ['./create-update-dictionary-form.component.scss']
})
export class CreateUpdateDictionaryFormComponent implements OnInit {
  public form: FormGroup;
  public enabled: boolean = false;
  public toggle: any = { isAquamarine: true, disabled: false };
  @Input() dictionaryItem: DictionaryItem;
  @Output() emitValues: EventEmitter<{dictionary: DictionaryItem, valid: boolean}> = new EventEmitter();

  constructor(
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      substitute: new FormControl(this.dictionaryItem?.substitute || '', [Validators.required]),
      replacement: new FormControl(this.dictionaryItem?.replacement_group.join(', ') || '', [Validators.required])
    });
    this.enabled = this.dictionaryItem?.enabled || false;
    this.emitValues.emit({dictionary: this.dictionaryItem, valid: this.form.valid})
  }

  public isFieldValid(name: string): boolean {
    const control = this.form.controls[name];
    return control.touched && !control.valid;
  }

  public onEmitFormValues(): void {
    const formValues = this.form.value;
    formValues.replacement = formValues.replacement.replace(/\s/g, "");
    let dictionary: DictionaryItem = {
      id: this.dictionaryItem?.id || null,
      substitute: formValues.substitute,
      replacement_group: formValues.replacement.split(','),
      enabled: this.enabled
    };
    this.emitValues.emit({dictionary: dictionary, valid: this.form.valid})
  }
}